import Icon from '../components/Icon.vue'

Icon.register({
  bicycle: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M512.5 192C496.1 191.9 480.5 195 466.1 200.5L388.4 75.3A24-24 0 0 1 368 64H304C295.2 64 288 71.2 288 80V96C288 104.8 295.2 112 304 112H354.6L369.5 136H256V120C256 111.2 248.8 104 240 104H152.5C139.1 104 127.8 115 128 128.4 128.2 141.5 138.9 152 152 152H200.7L171.3 199.5C157.9 194.7 143.4 192 128.3 192 58.1 191.8 0.4 249 0 319.2-0.4 390.3 57.1 448 128 448 187.6 448 237.8 407.2 252 352H304A24-24 0 0 1 324.4 340.6L410.4 201.8 425.3 225.8C399.9 249.3 383.9 282.9 384 320.3 384.1 389.1 441.9 447.3 510.7 448 581.3 448.7 638.9 392.2 640 322 641.1 251.1 583.5 192.3 512.5 192zM186.8 265.8C196.5 276.3 203.4 289.4 206.4 304H163.1L186.8 265.8zM128 400C83.9 400 48 364.1 48 320S83.9 240 128 240C133.9 240 139.6 240.7 145.1 241.9L99.6 315.4C89.7 331.3 101.2 352 120 352H201.3C188.9 380.2 160.7 400 128 400zM290.6 304H255C251 272.2 235.5 244.1 212.6 224L237.4 184H364.9L290.6 304zM507.7 399.9C466.7 397.7 433.6 364.2 432.1 323.1 431.3 302 438.7 282.6 451.4 267.9L495.8 339.5C500.5 347 510.4 349.3 517.9 344.6L531.5 336.2C539 331.5 541.3 321.6 536.6 314.1L492.1 242.5A79.9-79.9 0 0 0 512 240C556.1 240 592 275.9 592 320 592 365.5 553.8 402.3 507.7 399.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bicycle.js
// module id = LqPW
// module chunks = 144